module.exports = __webpack_public_path__ + "img/monitorManage.ed73cafa.svg";